var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"rt-plot-container",attrs:{"body-class":"rt-plot-body"}},[_c('vue-plotly',_vm._b({attrs:{"id":`${_vm.stream.data_table}--rt-plot`,"data":_vm.plotData,"layout":_vm.plotLayout}},'vue-plotly',_vm.plotOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }